import { Link, useLoaderData, type LoaderFunctionArgs } from 'react-router-dom';
import { fetchPostById } from '../api/articles';
import type { WpPost } from '../types';

export const articleDetailLoader = async ({
  params,
}: LoaderFunctionArgs): Promise<WpPost> => {
  const rawId = params.id;
  const id = Number(rawId);
  if (!rawId || !Number.isInteger(id) || id <= 0) {
    throw new Response('Invalid article id', { status: 400 });
  }
  try {
    return await fetchPostById(id);
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Unknown error';
    throw new Response(message, { status: 404 });
  }
};

export const ArticleDetailPage = (): JSX.Element => {
  const post = useLoaderData() as WpPost;

  return (
    <article>
      <Link to="/" style={{ fontSize: 12, color: '#1976d2' }}>
        ← 一覧へ戻る
      </Link>
      <h2
        style={{ fontSize: 22, marginTop: 16 }}
        dangerouslySetInnerHTML={{ __html: post.title.rendered }}
      />
      <p style={{ fontSize: 12, color: '#888' }}>
        投稿日: {new Date(post.date).toLocaleString('ja-JP')}
      </p>
      <div
        style={{ marginTop: 24, lineHeight: 1.8 }}
        dangerouslySetInnerHTML={{ __html: post.content.rendered }}
      />
    </article>
  );
};
